<template>
  <CommonLayout header="floristHeader" footer="floristFooter">
    <MeetingLayout :type="consts.meetingType.florist">
      <div class="base-color h-100 mh-550 shadow">
        <div class="p-2 h-100">
          <div class="text-center">
            <h4 class="pt-3">Best Wishes on Your Wedding.</h4>
            <p class="pt-3" style="white-space: pre-line; font-size: larger">
              お打ち合わせいただきありがとうございました<br>
              おふたりのフラワーコーディネートが素敵になりますよう<br>
              精一杯ご準備させていただきます<br>
              当日までどうぞよろしくお願いいたします
            </p>
          </div>

          <div style="position: relative;">
            <img class="w-100" :src="imageUrl" alt="meeting finish" />
            <div class="text-end position-absolute fixed-bottom mb-2" style="margin-right: 1rem !important;">
              <BButton
                variant="outline-primary"
                class="w-25 sub-button-color"
                @click="prevPage"
              >
                戻る
              </BButton>
  
              <BButton
                :variant="ishangUpDisabled ? 'primary' : 'outline-primary'"
                class="w-25 ms-3"
                :class="ishangUpDisabled ? 'disabled-button-color' : 'sub-button-color'"
                :disabled="ishangUpDisabled"
                @click="hangUp"
              >
                接続終了
              </BButton>
            </div>
          </div>
        </div>
      </div>
    </MeetingLayout>
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import MeetingLayout from '@/layout/MeetingLayout'
import SignalingModel from '@/models/SignalingModel'
import mstore from '@/store/meeting-store'
import logoff from '@/mixins/logoff'

// BootstrapVueNext
import { BButton } from 'bootstrap-vue-next'

export default {
  name: 'FloristMeetingFinish',
  components: {
    CommonLayout,
    MeetingLayout,
    BButton
  },
  computed: {
    getIsTargetAtendeeActive () {
      return mstore.getters.isTargetAtendeeActive
    }
  },
  data () {
    return {
      ishangUpDisabled: false,
      imageUrl: ''
    }
  },
  methods: {
    // 戻る
    prevPage () {
      const targetPath = '/florist/meeting/estimate'
      SignalingModel.sendClickEvent('prev', this, {
        target_path: targetPath.replace('florist', 'customer')
      })
      this.$router.push(targetPath)
    },
    // 通話終了
    async hangUp () {
      sessionStorage.setItem('noDisplayMessageFlag', 'true')
      this.ishangUpDisabled = true

      await SignalingModel.sendClickEvent('hangUp', this)

      if (logoff.logoff_kyoutu()) {
        sessionStorage.removeItem('meeting')
        sessionStorage.removeItem('attendee')
        sessionStorage.removeItem('myselfTileId')
        sessionStorage.removeItem('yourselfTileId')
        sessionStorage.removeItem('guest1TileId')
        sessionStorage.removeItem('guest2TileId')
        sessionStorage.removeItem('guest3TileId')
        sessionStorage.removeItem('hideMySelfVideo')
        sessionStorage.removeItem('hideYourSelfVideo')
        sessionStorage.removeItem('hideGuest1SelfVideo')
        sessionStorage.removeItem('hideGuest2SelfVideo')
        sessionStorage.removeItem('hideGuest3SelfVideo')
      }

      return false
    }
  },
  mounted () {
    sessionStorage.removeItem('lastRoutePath')
    sessionStorage.removeItem('floristIsOperationPossible')
    this.imageUrl = this.config.imageURL + '/meeting-contents/mtg-finish.jpg'
  }
}
</script>
